import React from "react";
import { useParams } from "react-router-dom";
import SearchResultDetailPage from "./SearchResultDetailPage";

function ResourceListResourcePage({ shared }) {
  const { id: listId, resourceId } = useParams();
  const prefix = shared ? "/shared/resource-lists" : "/my211/resource-lists";

  return (
    <SearchResultDetailPage
      overrideId={resourceId}
      backUrl={`${prefix}/${listId}`}
      backLabel="Back to List"
    />
  );
}

export default ResourceListResourcePage;
